
export const appConfig = {
    appName: "Push AI",
    initiatives: [ 'client' ],
    prismicRepository: 'push-ai',
    assistantId: "asst_8iz6axdlgS3YuQna23knN106",
    namespace: 'https://agents.dial360.io',
    auth0: false,
    auth0_domain: "auth.agents.dial360.io",
    auth0_clientId: "not_enabled",
    auth0_scope: "read:current_user read:current_user_metadata",
    email_verification: false,
    signup_allowed: false,
    signin_google: false,
    stripe_enabled: false,
    display_mode: "dark",
    initiativeThread: false,
    initiativeThreadSummaries: false,
    initiativeTypes: [ "client" ],
    initiativeAssistants: {
        "client_disabled": "asst_8iz6axdlgS3YuQna23knN106"
    }
};

export const firebaseConfig = {
    apiKey: "AIzaSyD6GCkgOu9AXpto7kt20GtmUn7mqH7hkSg",
    authDomain: "push-ai-team.firebaseapp.com",
    projectId: "push-ai-team",
    storageBucket: "push-ai-team.appspot.com",
    messagingSenderId: "23948462232",
    appId: "1:23948462232:web:02516c69ce0bef5d3ce8ed",
    measurementId: "G-4S9D2SEJC7"
  };